module.exports = [{
      plugin: require('/home/jli/projects/xiaoju-sites/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/jli/projects/xiaoju-sites/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
